import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false }) => (
  <p
    className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] ${
      dark ? "text-lec-bone/60" : "text-lec-charcoal"
    }`}
  >
    <span className="inline-block h-2 w-2 bg-lec-green" />
    {children}
  </p>
);
